// extracted by mini-css-extract-plugin
module.exports = {"container":"_app_container__iy82q","main":"_app_main__coXXh"};